<div class="scroll-to-top" [class.visible]="isVisible$ | async">
  <button
    mat-mini-fab
    color="accent"
    type="button"
    matTooltip="Back to the top"
    matTooltipPosition="left"
    aria-label="Back to the top"
    (click)="scrollToTop()"
  >
    <mat-icon>arrow_upward</mat-icon>
  </button>
</div>
